import React from 'react';
import Badge from '../components/Badge';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';

const POST_FRAGMENT = gql(`
  # eslint-disable-next-line @graphql-eslint/require-selections
  fragment PostBadge_post on Post {
    archivedAt
    publishedAt
  }
`);

interface PostBadgeProps {
  post: DocumentType<typeof POST_FRAGMENT>;
  inline?: boolean;
}

const PostBadge = ({ post, inline }: PostBadgeProps) => {
  if (post.publishedAt === null) {
    return <Badge inline={inline}>Draft</Badge>;
  }

  if (post.archivedAt) {
    return (
      <Badge color="gray" inline={inline}>
        Archived
      </Badge>
    );
  }

  return null;
};

export default PostBadge;
